import React from 'react';
import { SpaceBetween, FormField, Input, Grid } from '@cloudscape-design/components';
import TextEditor, { FileData } from '../textEditor/TextEditor';
import { FileMetadata } from '../FileDisplay';
import { MARKDOWN_TEXT_WARNING } from 'src/contstant/commonLabels';

export interface TaskData {
  taskName: string;
  taskDescription: string;
  taskDurationDays: number;
}

interface TaskFormProps {
  taskData: TaskData;
  onTaskChange: (updates: Partial<TaskData>) => void;
  onMediaChange?: (data: FileData[]) => void;
  onFilesChange?: (data: { files: File[]; metadata: FileMetadata[] }) => void;
  initialFileMetadata?: FileMetadata[];
  labels?: {
    nameLabel?: string;
    descriptionLabel?: string;
  };
  mediaKey?: string;
  enableFileUploads?: boolean;
}

const TaskForm: React.FC<TaskFormProps> = ({
  taskData,
  onTaskChange,
  onMediaChange,
  onFilesChange,
  initialFileMetadata = [],
  labels = {
    nameLabel: 'Task Name',
    descriptionLabel: 'Task Description',
  },
  mediaKey = 'taskDescription',
  enableFileUploads = true,
}) => {
  return (
    <SpaceBetween size="l">
      <Grid gridDefinition={[{ colspan: { default: 9 } }, { colspan: { default: 3 } }]}>
        <FormField label={labels.nameLabel} stretch data-testid="task-name-field">
          <Input
            data-testid="task-name-input"
            value={taskData.taskName}
            onChange={({ detail }) => {
              onTaskChange({ taskName: detail.value });
            }}
          />
        </FormField>
        <FormField label="Duration (Days)" stretch data-testid="task-duration-field">
          <Input
            data-testid="task-duration-input"
            type="number"
            value={taskData.taskDurationDays?.toString() || '1'}
            onChange={({ detail }) => {
              const value = Math.max(1, parseInt(detail.value) || 1);
              onTaskChange({ taskDurationDays: value });
            }}
          />
        </FormField>
      </Grid>

      <FormField
        label={labels.descriptionLabel}
        stretch
        description={MARKDOWN_TEXT_WARNING}
        data-testid="task-description-field"
      >
        <TextEditor
          data-testid="task-description-editor"
          placeholder="Enter task description..."
          value={taskData.taskDescription}
          onChange={(value) => {
            onTaskChange({ taskDescription: value });
          }}
          onChangeMedia={(data) => {
            if (onMediaChange) {
              onMediaChange(data);
            }
          }}
          onFilesChange={(data) => {
            if (onFilesChange) {
              onFilesChange(data);
            }
          }}
          showFileUpload={enableFileUploads}
          initialFileMetadata={initialFileMetadata}
        />
      </FormField>
    </SpaceBetween>
  );
};

export default TaskForm;
